import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Configuration } from '../config/config';
import 'rxjs/add/operator/map';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UserStatusService {
  public jwtToken: string;
  constructor(private httpClient: HttpClient, private http: Http,private cookieService: CookieService) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    } else {
      this.jwtToken = sessionStorage.getItem('Token');
    }
  }

  validateUser(data){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateCommunityUserGameLink', data)
      .map((res: any)=>res)
  }

  ltiValidateUser(data){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/newValidationlink', data)
      .map((res: any)=>res)
  }

  projectGrading(obj){
    let headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    // headers.append('Cache-Control', 'no-cache');
    // headers.append('Pragma', 'no-cache');
    // headers.append('Referrer-Policy', 'no-referrer');
    // headers.append('Set-cookie', 'abc');
    // headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('Access-Control-Allow-Credentials', 'true');
    let options = new RequestOptions({ headers: headers });
    return this.http.post(Configuration.Server+ 'project/grading',obj)
      .map((res: any)=>res)
  }

  saveCourseTransaction(obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/course_transaction', obj)
      .map((res: any)=>res)
  }
  ltisaveCourseTransaction(obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/lticourse_transaction', obj)
      .map((res: any)=>res)
  }

  getGameJsonData(gameName,flag,language, data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/readFile/'+ gameName +'/' + flag+'/'+language, data)
      .map((res: any)=>res)
  }

  validateGuestUrl(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateGuestUrl', data)
      .map((res: any)=>res)
  }

  updateGuestGameStatus(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/updateGuestGameStatus', data)
      .map((res: any)=>res)
  }

  updatePlayedCertificateSteps(transaction_obj){


    return this.httpClient.put(Configuration.ServerWithApiUrl+'/updatePlayedCertificateSteps', transaction_obj)
      .map((res: any)=>res)
  }

  getLinkDetails(link_id){

    return this.httpClient.get(Configuration.ServerWithApiUrl+'/getLinkDetails/' + link_id)
      .map((res: any)=>res)
  }

  getJWTToken(token, comm_id){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Authorization', `${token}`);
    let options = new RequestOptions({ headers: headers });

    return this.http.get(Configuration.ServerWithApiUrl+'/getUserJWTToken/'+comm_id, options)
      .map(res=>res.json())
  }

  validateCommunityUserVideoLink(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateCommunityUserVideoLink', data)
      .map((res: any)=>res)
  }

  validateCommunityUserAssessmentLink(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateCommunityUserAssessmentLink', data)
      .map((res: any)=>res)
  }

  validateGameContentLauncher(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateGameContentLauncher', data)
      .map((res: any)=>res)
  }

  validateVideoContentLauncher(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateVideoContentLauncher', data)
      .map((res: any)=>res)
  }

  validateAssessmentContentLauncher(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateAssessmentContentLauncher', data)
      .map((res: any)=>res)
  }

  saveAssessmentForUser(obj){


    return this.httpClient.post(Configuration.ServerWithApiUrl+'/assessment_evaluation', obj)
      .map((res: any)=>res)
  }

  getCourseByIdWithLevelWiseProgress(obj){


    return this.httpClient.post(Configuration.ServerWithApiUrl+'/course_with_level_progress/'+ obj.course_id, obj)
      .map((res: any)=>res)
  }

  getAssessmentById(id, lang_id){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/assessment_details/'+ id + '/' + lang_id)
      .map((res: any)=>res)
  }

  updateLearnerTransaction(transaction_obj){

   
    return this.httpClient.post(Configuration.ServerWithApiUrl+'/learner_transaction', transaction_obj)
      .map((res: any)=>res)
  }

  getVideoById(id, lang_id, lang_name){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/video/'+ id + '/' + lang_id +'/' + lang_name)
      .map((res: any)=>res)
  }

  getCertificateTransaction(course_id, certificate_id, user_name){

    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getCertificateTransaction/'+course_id+'/'+certificate_id+'/'+user_name )
      .map((res: any)=>res)
  }

  courseTransactionByLevelId(id, level, user_name){

    return this.httpClient.get(Configuration.ServerWithApiUrl + '/courseTransactionByLevelId/'+id+'/'+level+'/'+user_name )
      .map((res: any)=>res)
  }

  returnScoreToCommunity(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/returnScoreToCommunity',data)
      .map((res: any)=>res)
  }

  getCourseById(course_id, lang){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/courses/'+course_id + '/' + lang)
      .map((res: any)=>res)
  }

  validateCommunityUserCertificateLink(data){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/validateCommunityUserCertificateLink', data)
      .map((res: any)=>res)
  }

  getResourceConfiguration(id){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getResourceConfig/'+id)
      .map((res: any) => res)
  }

  saveUserGameDetails(data){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/saveUserGameDetails', data)
      .map((res: any)=>res)
  }

  getGameAttempts(data){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/getGameAttempts', data)
      .map((res: any)=>res)
  }

  getUserGameDetails(user_id, commId, gameId){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getUserGameDetails/' + user_id + '/' + commId + '/' + gameId)
      .map((res: any) => res)
  }

  getCommunityNameByCommunityID(communityID){
    return this.httpClient.get(Configuration.ServerWithApiUrl+'/communityName/'+communityID)
      .map((res: any)=>res)
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/user-status.service.ts